// extracted by mini-css-extract-plugin
export default {"label":"FinaleType-label-UAcQq Label-label-DYldh"};